import React, { useRef, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { Check } from "lucide-react";
import CustomPopup from "./Popup/custom-popup";
import Form from 'react-bootstrap/Form';
import { isValidEmail } from "../utils/utils";

const ToolCard = ({
  index,
  title,
  description,
  features = [],
  icon: Icon,
  image,
  imageAlt,
  buttonText = "Click here to access this free tool",
  buttonUrl,
  reverseLayout = false,
  badgeText = "Free Tool"
}) => {
  const captchaRef = useRef(null);
  const isEven = (index % 2 === 0);
  const bg = isEven ? "bg-light-blue" : "bg-white";

  const [show, setShow] = React.useState(false);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [currentUrl, setCurrentUrl] = useState(null);

  const popupCloseHandler = (e) => {
    setShow(false);
  };

  const checkAccess = (currentUrl) => {
    setCurrentUrl(currentUrl);
    // get cookie name hasAccessed
    const hasAccessed = document.cookie.split('; ').find(row => row.startsWith('hasAccessed='));
    if (hasAccessed && hasAccessed.split('=')[1] === 'true') {
      setShow(false);
      window.open(currentUrl);
      return;
    } else {
      // if not found
      setShow(true);
    }
  }

  const enterAITool = (e) => {
    e.preventDefault();
    if (!name || !email || !isValidEmail(email) || !phone) {
      alert('Please input valid information');
      return;
    }

    const token = captchaRef.current.getValue();
    if (!token) {
      alert("Please Confirm You Are Not a Robot!");
      return;
    }

    // set cookie hasAccessed = true
    document.cookie = "hasAccessed=true; path=/; max-age=" + 60 * 60 * 24 * 30; // 30 days

    // call api
    const data = {
      recaptchaToken: token,
      email: email,
      name: name,
      phone: phone,
      subject: `[Inventiv] [${name}, ${email}] Access AI Tool`,
      message: '',
      site: 'inventiv.org'
    }
    // Add to our database
    fetch("https://api.trustyip.com/subcribers/add", {
      "method": "POST",
      "headers": {
        "content-type": "application/json",
        "accept": "application/json"
      },
      "body": JSON.stringify(data)
    })
      .then(response => response.json())
      .then(response => {
        setShow(false);
        //
        window.open(currentUrl);
      })
      .catch(err => {
        console.log(err);
      }).finally(() => {
        setShow(false);
        window.open(currentUrl);
      });
  };

  const imageRow = () => {
    return (
      <div className="col-12 col-md-6 wow p-5">
        <img
          src={image}
          alt={imageAlt}
          width="100%"
          style={{ height: '60vh' }}
        />
      </div>
    );
  };

  const textRow = () => {
    return (
      <div className={`col-12 col-md-6 wow fadeInLeft delay-04s p-5 ${bg}`}>
        <h1 className="bold sec-clr mt-1">{title}</h1>
        <p className="sec-clr f-16">
          {description}
        </p>

        {features.length > 0 && (
          <div className="space-y-4 my-3">
            {features.map((feature, index) => (
              <div key={index}>
                {typeof feature === 'string' ? (
                  <div className="flex items-center">
                    <Check className="text-green-500 mr-3 h-4 w-4 flex-shrink-0" />
                    <span className="text-gray-700">{feature}</span>
                  </div>
                ) : (
                  <>
                    <div className="flex items-center mb-1">
                      {/* <Check className="text-green-500 mr-3 h-4 w-4 flex-shrink-0" /> */}
                      <h4 className="font-semibold text-gray-800">{feature.title}</h4>
                    </div>
                    <p className="text-gray-600 text-sm ml-7">{feature.description}</p>
                  </>
                )}
              </div>
            ))}
          </div>
        )}

        <button
          onClick={() => { checkAccess(buttonUrl) }}
          className="btn btn-default"
        >
          {buttonText}
        </button>
      </div>
    );
  };

  return (
    <>
      <section className="pt-3 pb-3 mt-3 mb-3" id="learn-more">
        <div className="container">
          <div className="row">
            {isEven ? (
              <>
                {textRow()}
                {imageRow()}
              </>
            ) : (
              <>
                {imageRow()}
                {textRow()}
              </>
            )}
          </div>
        </div>
      </section>
      <CustomPopup
        onClose={popupCloseHandler}
        show={show}
        title="">
        <div>
            <h5 className="text-center fw-bold mb-4">Please provide your contact information</h5>
            <Form >
              <Form.Group className="mb-2" controlId="formBasicName">
                {/* <Form.Label>Your Name</Form.Label> */}
                <Form.Control type="text" placeholder="Your Name" required="true" value={name} onChange={e => setName(e.target.value)} />
              </Form.Group>

              <Form.Group className="mb-2" controlId="formBasicEmail">
                {/* <Form.Label className="text-bold">Your Email</Form.Label> */}
                <Form.Control type="email" placeholder="Your email" required="true" value={email} onChange={e => setEmail(e.target.value)} />
              </Form.Group>

              <Form.Group className="mb-2" controlId="formBasicPhone">
                {/* <Form.Label className="text-bold">Your Phone</Form.Label> */}
                <Form.Control type="tel" placeholder="Your phone number" required="true" value={phone} onChange={e => setPhone(e.target.value)} />
              </Form.Group>

              <Form.Group className="mb-2">
                <ReCAPTCHA
                  sitekey={process.env.RECAPTCHA_SITE_KEY}
                  ref={captchaRef}
                />
              </Form.Group>

              <button type="button" className='btn btn-default w-100' onClick={enterAITool}>ENTER</button>
            </Form>
          </div>
      </CustomPopup>
    </>
  );
};

export default ToolCard;
